import { Loader } from "@campgladiator/cgui-core.atoms.loader";
import { Paragraph } from "@campgladiator/cgui-core.atoms.typography";
import React from "react";
import styles from "./SelectSwapType.module.scss";

export type SelectSwapTypeProps = {
  isPriceLoading: boolean;
};

const SelectSwapType = ({ isPriceLoading }: SelectSwapTypeProps) => (
  <>
    {isPriceLoading && <Loader className={styles.loader} />}
    <Paragraph weight="book">
      Restarting sets payments made to 0 on the new membership.
    </Paragraph>
    <Paragraph weight="book">
      Rollover starts the new membership at the current payments made.
    </Paragraph>
  </>
);

export default SelectSwapType;
